//*** 公用常量 ***

//1.电话号码格式验证正则表达式**
const telreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
//2.身份证号码格式验证正则表达式**
const cardreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
//3.邮箱格式验证正则表达式**
const emailreg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
//4.限中文 **
const testExpress = /[^\u4E00-\u9FA5]/g;
//5.去除html标签
const htmlReg = /<\/?[^>]*>/g;

// 调用token接口时必传参数
const grant_type = 'refresh_token';
const client_id = 'huihang-admin';
const client_secret = 'zsb.web.secret';

// signalR客户端连接地址
const signalRDomain = "http://8.136.215.63:5100"; //测试环境
// const signalRDomain = ishttps == 'http:'?"http://w.huihangedu.cn":"https://w.huihangedu.cn";//生产环境
export {
    telreg,
    cardreg,
    testExpress,
    emailreg,
    htmlReg,
    grant_type,
    client_id,
    client_secret,
    signalRDomain,
}